import { Injectable, Injector, Type, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DOCUMENT } from '@angular/common';
import { IEnvironment } from '@core/interfaces';

import { tap } from 'rxjs/operators';
import { lastValueFrom } from 'rxjs';
import { ConfigurationParameters } from '@elesgergo/ikont-web-client-sdk';
import { environment } from 'src/environments/environment';
import { HttpUrlEncodingCodec } from '@angular/common/http';

export const appInitializer = (envService: EnvironmentService) => {
  return () => envService.loadEnvironment();
};

export const apiConfigInitializer = (
  envService: EnvironmentService
): string => {
  const params: ConfigurationParameters = {
    basePath: envService.environment.apiUrlV1,
    encoder: new HttpUrlEncodingCodec(),
  };
  return envService.environment.apiUrlV1;
};

@Injectable({
  providedIn: 'root',
})
export class EnvironmentService {
  private injector = inject(Injector);
  private document = inject<Document>(DOCUMENT);

  compiledEnvironment: { production: boolean; ci: boolean } = environment;
  private _environment!: IEnvironment;
  get environment(): IEnvironment {
    return this._environment;
  }

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);
  constructor() {}

  private environmentSelector(): string {
    const hostName = this.document.location.hostname;

    // Ha CI flag aktív, pl. mindig stage configot akarunk
    if (this.compiledEnvironment.ci) {
      return '/assets/environment/environment.stage.json';
    }

    // Egyértelmű domain → config mapping
    switch (hostName) {
      case 'localhost':
      case '127.0.0.1':
        return '/assets/environment/environment.local.json';

      case 'dev.ikont-web.ikont.net':
        return '/assets/environment/environment.dev.json';

      case 'stage.ikont-web.ikont.net':
        return '/assets/environment/environment.stage.json';

      case 'ikont-web.ikont.net':
        return '/assets/environment/environment.prod.json';

      default:
        // Feature domainek pl. feature-xyz.ikont-web.ikont.net
        if (hostName.includes('ikont-web-feature')) {
          return '/assets/environment/environment.dev.json'; // vagy stage, ahogy szeretnéd
        }

        console.warn(`Ismeretlen domain: ${hostName}, fallback PROD configra.`);
        return '/assets/environment/environment.prod.json';
    }
  }

  loadEnvironment() {
    const http = this.injector.get<HttpClient>(HttpClient as Type<HttpClient>);
    const envUrl = this.environmentSelector();

    // (Opcionális) cache busting, hogy ne ragadjon be régi JSON
    const urlWithTs = `${envUrl}?t=${new Date().getTime()}`;

    const environment$ = http.get<IEnvironment>(urlWithTs).pipe(
      tap((env) => {
        this._environment = env;
      })
    );
    return lastValueFrom(environment$);
  }
}


